import { useTheme } from '@themenu/design-system'
import styled from 'styled-components'

const shimmerColors = {
  light: 'rgba(0, 0, 0, 0.12)',
  dark: 'rgba(255, 255, 255, 0.5)',
} as const

const SkeletonLoader = styled.span<{ $shimmerMid: string }>`
  width: 100%;
  height: 15px;
  display: block;
  background: linear-gradient(
      to right,
      transparent,
      ${(props) => props.$shimmerMid} 50%,
      transparent 80%
    ),
    transparent;
  background-repeat: repeat-y;
  background-size: 50px 500px;
  background-position: 0 0;
  animation: shine 1s infinite;

  @keyframes shine {
    to {
      background-position: 100% 0, 0 0;
    }
  }
`

export const Loader = (): JSX.Element => {
  const theme = useTheme()
  const backgroundColor = theme.colors.background.default
  const isDark = theme.name === 'dark'
  const shimmerMid = isDark ? shimmerColors.dark : shimmerColors.light

  return (
    <div style={{ backgroundColor, minHeight: '100dvh' }}>
      <SkeletonLoader data-testid="loader" $shimmerMid={shimmerMid} />
    </div>
  )
}
